const PINNED_CODES = ['RU', 'KZ'];

const RAW = [
  ['AU', 'Австралия'],
  ['AT', 'Австрия'],
  ['AZ', 'Азербайджан'],
  ['AL', 'Албания'],
  ['DZ', 'Алжир'],
  ['AS', 'Американское Самоа'],
  ['AI', 'Ангилья'],
  ['AO', 'Ангола'],
  ['AD', 'Андорра'],
  ['AG', 'Антигуа и Барбуда'],
  ['AR', 'Аргентина'],
  ['AM', 'Армения'],
  ['AW', 'Аруба'],
  ['AF', 'Афганистан'],
  ['BS', 'Багамы'],
  ['BD', 'Бангладеш'],
  ['BB', 'Барбадос'],
  ['BH', 'Бахрейн'],
  ['BY', 'Беларусь'],
  ['BZ', 'Белиз'],
  ['BE', 'Бельгия'],
  ['BJ', 'Бенин'],
  ['BM', 'Бермуды'],
  ['BG', 'Болгария'],
  ['BO', 'Боливия'],
  ['BQ', 'Бонэйр, Синт-Эстатиус и Саба'],
  ['BA', 'Босния и Герцеговина'],
  ['BW', 'Ботсвана'],
  ['BR', 'Бразилия'],
  ['BN', 'Бруней'],
  ['BF', 'Буркина-Фасо'],
  ['BI', 'Бурунди'],
  ['BT', 'Бутан'],
  ['VU', 'Вануату'],
  ['GB', 'Великобритания'],
  ['HU', 'Венгрия'],
  ['VE', 'Венесуэла'],
  ['VG', 'Виргинские острова (Брит.)'],
  ['VI', 'Виргинские острова (США)'],
  ['TL', 'Восточный Тимор'],
  ['VN', 'Вьетнам'],
  ['GA', 'Габон'],
  ['HT', 'Гаити'],
  ['GY', 'Гайана'],
  ['GM', 'Гамбия'],
  ['GH', 'Гана'],
  ['GP', 'Гваделупа'],
  ['GT', 'Гватемала'],
  ['GN', 'Гвинея'],
  ['GW', 'Гвинея-Бисау'],
  ['DE', 'Германия'],
  ['GG', 'Гернси'],
  ['GI', 'Гибралтар'],
  ['HN', 'Гондурас'],
  ['HK', 'Гонконг'],
  ['GD', 'Гренада'],
  ['GL', 'Гренландия'],
  ['GR', 'Греция'],
  ['GE', 'Грузия'],
  ['GU', 'Гуам'],
  ['DK', 'Дания'],
  ['JE', 'Джерси'],
  ['DJ', 'Джибути'],
  ['DM', 'Доминика'],
  ['DO', 'Доминиканская Республика'],
  ['CD', 'ДР Конго'],
  ['EG', 'Египет'],
  ['ZM', 'Замбия'],
  ['ZW', 'Зимбабве'],
  ['IL', 'Израиль'],
  ['IN', 'Индия'],
  ['ID', 'Индонезия'],
  ['JO', 'Иордания'],
  ['IQ', 'Ирак'],
  ['IR', 'Иран'],
  ['IE', 'Ирландия'],
  ['IS', 'Исландия'],
  ['ES', 'Испания'],
  ['IT', 'Италия'],
  ['YE', 'Йемен'],
  ['CV', 'Кабо-Верде'],
  ['KZ', 'Казахстан'],
  ['KH', 'Камбоджа'],
  ['CM', 'Камерун'],
  ['CA', 'Канада'],
  ['QA', 'Катар'],
  ['KE', 'Кения'],
  ['CY', 'Кипр'],
  ['KG', 'Кыргызстан'],
  ['KI', 'Кирибати'],
  ['CN', 'Китай'],
  ['KP', 'КНДР'],
  ['CO', 'Колумбия'],
  ['KM', 'Коморы'],
  ['CG', 'Конго'],
  ['CR', 'Коста-Рика'],
  ['CI', 'Кот-д’Ивуар'],
  ['CU', 'Куба'],
  ['KW', 'Кувейт'],
  ['CW', 'Кюрасао'],
  ['LA', 'Лаос'],
  ['LV', 'Латвия'],
  ['LS', 'Лесото'],
  ['LR', 'Либерия'],
  ['LB', 'Ливан'],
  ['LY', 'Ливия'],
  ['LT', 'Литва'],
  ['LI', 'Лихтенштейн'],
  ['LU', 'Люксембург'],
  ['MU', 'Маврикий'],
  ['MR', 'Мавритания'],
  ['MG', 'Мадагаскар'],
  ['YT', 'Майотта'],
  ['MO', 'Макао'],
  ['MW', 'Малави'],
  ['MY', 'Малайзия'],
  ['ML', 'Мали'],
  ['MV', 'Мальдивы'],
  ['MT', 'Мальта'],
  ['MA', 'Марокко'],
  ['MQ', 'Мартиника'],
  ['MH', 'Маршалловы Острова'],
  ['MX', 'Мексика'],
  ['FM', 'Микронезия'],
  ['MZ', 'Мозамбик'],
  ['MD', 'Молдова'],
  ['MC', 'Монако'],
  ['MN', 'Монголия'],
  ['MS', 'Монтсеррат'],
  ['MM', 'Мьянма'],
  ['NA', 'Намибия'],
  ['NR', 'Науру'],
  ['NP', 'Непал'],
  ['NE', 'Нигер'],
  ['NG', 'Нигерия'],
  ['NL', 'Нидерланды'],
  ['NI', 'Никарагуа'],
  ['NZ', 'Новая Зеландия'],
  ['NC', 'Новая Каледония'],
  ['NO', 'Норвегия'],
  ['AE', 'ОАЭ'],
  ['OM', 'Оман'],
  ['KY', 'Острова Кайман'],
  ['CK', 'Острова Кука'],
  ['TC', 'Острова Теркс и Кайкос'],
  ['PK', 'Пакистан'],
  ['PW', 'Палау'],
  ['PS', 'Палестина'],
  ['PA', 'Панама'],
  ['PG', 'Папуа — Новая Гвинея'],
  ['PY', 'Парагвай'],
  ['PE', 'Перу'],
  ['PL', 'Польша'],
  ['PT', 'Португалия'],
  ['PR', 'Пуэрто-Рико'],
  ['RE', 'Реюньон'],
  ['RU', 'Россия'],
  ['RW', 'Руанда'],
  ['RO', 'Румыния'],
  ['SV', 'Сальвадор'],
  ['WS', 'Самоа'],
  ['SM', 'Сан-Марино'],
  ['ST', 'Сан-Томе и Принсипи'],
  ['SA', 'Саудовская Аравия'],
  ['MK', 'Северная Македония'],
  ['MP', 'Северные Марианские острова'],
  ['SC', 'Сейшелы'],
  ['SN', 'Сенегал'],
  ['VC', 'Сент-Винсент и Гренадины'],
  ['KN', 'Сент-Китс и Невис'],
  ['LC', 'Сент-Люсия'],
  ['RS', 'Сербия'],
  ['SG', 'Сингапур'],
  ['SX', 'Синт-Мартен'],
  ['SY', 'Сирия'],
  ['SK', 'Словакия'],
  ['SI', 'Словения'],
  ['SB', 'Соломоновы Острова'],
  ['SO', 'Сомали'],
  ['SD', 'Судан'],
  ['SR', 'Суринам'],
  ['US', 'США'],
  ['SL', 'Сьерра-Леоне'],
  ['TJ', 'Таджикистан'],
  ['TH', 'Таиланд'],
  ['TW', 'Тайвань'],
  ['TZ', 'Танзания'],
  ['TG', 'Того'],
  ['TK', 'Токелау'],
  ['TO', 'Тонга'],
  ['TT', 'Тринидад и Тобаго'],
  ['TV', 'Тувалу'],
  ['TN', 'Тунис'],
  ['TM', 'Туркменистан'],
  ['TR', 'Турция'],
  ['UG', 'Уганда'],
  ['UZ', 'Узбекистан'],
  ['UA', 'Украина'],
  ['WF', 'Уоллис и Футуна'],
  ['UY', 'Уругвай'],
  ['FO', 'Фарерские острова'],
  ['FJ', 'Фиджи'],
  ['PH', 'Филиппины'],
  ['FI', 'Финляндия'],
  ['FK', 'Фолклендские острова'],
  ['FR', 'Франция'],
  ['GF', 'Французская Гвиана'],
  ['PF', 'Французская Полинезия'],
  ['HR', 'Хорватия'],
  ['CF', 'ЦАР'],
  ['TD', 'Чад'],
  ['ME', 'Черногория'],
  ['CZ', 'Чехия'],
  ['CL', 'Чили'],
  ['CH', 'Швейцария'],
  ['SE', 'Швеция'],
  ['SJ', 'Шпицберген и Ян-Майен'],
  ['LK', 'Шри-Ланка'],
  ['EC', 'Эквадор'],
  ['GQ', 'Экваториальная Гвинея'],
  ['ER', 'Эритрея'],
  ['SZ', 'Эсватини'],
  ['EE', 'Эстония'],
  ['ET', 'Эфиопия'],
  ['ZA', 'ЮАР'],
  ['KR', 'Южная Корея'],
  ['SS', 'Южный Судан'],
  ['JM', 'Ямайка'],
  ['JP', 'Япония'],
  ['XK', 'Косово'],
];

function compareCountries(a, b) {
  const pinA = PINNED_CODES.indexOf(a.code);
  const pinB = PINNED_CODES.indexOf(b.code);
  const rankA = pinA === -1 ? PINNED_CODES.length : pinA;
  const rankB = pinB === -1 ? PINNED_CODES.length : pinB;
  if (rankA !== rankB) {
    return rankA - rankB;
  }
  return a.name.localeCompare(b.name, 'ru');
}

export const COUNTRIES = RAW.map(([code, name]) => ({ code, name })).sort(compareCountries);

export function normalizeCountryCode(value) {
  if (!value || typeof value !== 'string') return null;
  const code = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? code : null;
}

export function getCountryByCode(code) {
  const normalized = normalizeCountryCode(code);
  if (!normalized) return null;
  return COUNTRIES.find((country) => country.code === normalized) || null;
}

export function getCountryName(code) {
  const found = getCountryByCode(code);
  return found ? found.name : null;
}

export function findCountryByName(name) {
  const raw = String(name || '').trim().toLowerCase();
  if (!raw) return null;
  return COUNTRIES.find((country) => country.name.toLowerCase() === raw) || null;
}

export function resolveCountryCode(payload) {
  if (!payload) return null;
  const fromCode = getCountryByCode(
    payload.countryCode || payload.CountryCode || payload.code || payload.country_code
  );
  if (fromCode) return fromCode.code;
  const fromName = findCountryByName(payload.country || payload.Country || payload.name);
  return fromName ? fromName.code : null;
}

export function filterCountries(query, list = COUNTRIES) {
  const raw = (query || '').trim().toLowerCase();
  if (!raw) return list;
  return list.filter((country) => {
    if (country.name.toLowerCase().includes(raw)) return true;
    if (country.code.toLowerCase() === raw) return true;
    return false;
  });
}

export const COUNTRY_SELECT_OPTIONS = COUNTRIES.map((country) => ({
  value: country.code,
  label: country.name,
}));

